// Zentrale Weiche für automatische Backup-Trigger (24h-Master & 72h-GlobalSettings).
// Manuelle Exporte dürfen diese Funktion NIEMALS durchlaufen.
export const shouldBypassAutoBackup = (): boolean => {
    if (typeof window === 'undefined') return false;

    // Mobil-Bypass: Auf kleinen Screens keine automatischen Backup-Modals erzwingen.
    if (window.innerWidth < 768) return true;

    // Localhost-Bypass
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return true;

    // Dev-Bypass (CRA/craco setzt NODE_ENV zur Buildzeit)
    if (process.env.NODE_ENV === 'development') return true;

    return false;
};
